import { request } from '../../utils/request';

export const getConversationById = (id: number, authToken: string) => {
  return request({
    method: 'GET',
    url: `/messaging/conversations/${id}`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
